module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Lock-5958e232368e1768b13c23a77eb591297142daeec2837d749d4bf54000bb000d.svg";